import { AfterViewInit, Component, DestroyRef, OnInit, ViewChild, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormBuilder, FormGroup, NgForm } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Table } from "primeng/table";
import { environment } from "../../../environments/environment";
import { ArkUserType, ClientModel, ClientUserViewModel, ClientUserViewModelPrimeDatatableResults, ClientViewModel } from "../../core/api/models";
import { ClientsApiService, ClientUsersApiService } from "../../core/api/services";
import { Utils } from "../../core/utils";
import { AuthService } from "../../main/auth.service";
import { ClientService } from '../';
import { AlertService } from "../../shared/services/alert.service";

@Component({
  selector: 'app-client-users',
  templateUrl: './client-users.component.html',
  standalone: false
})
export class ClientUsersComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private listRequest = 0;


  public pageTitle: string = 'Client Users';

  filter: any = {};
  list?: ClientUserViewModelPrimeDatatableResults;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;;

  itemFormGroup!: FormGroup;
  currentItem?: ClientModel;
  client_id: number | null = null;
  baseDomain: string | null = environment.baseDomain;

  clientLoginItem?: ClientUserViewModel;
  clientLoginVisible: boolean = false;
  clientLoginUrl: string | null = null;

  client_users: any[] | null = null;
  loading: boolean = false;
  loadingClientUsers: boolean = false;
  constructor(private authService: AuthService,
    private readonly clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private clientUsersApi: ClientUsersApiService,
    private sanitizer: DomSanitizer) {
  }


  ngOnInit(): void {
    this.clientService.getCurrentClient().subscribe((client) => {

      if (client){
         this.currentItem = client;
          this.client_id = client.ID||0;;
          this.loadingList = false;
        this.load();
    }
    });


    this.authService.checkIfAutorized([ArkUserType.Admin, ArkUserType.Support]);
    
  }

  ngAfterViewInit(): void {

  }



  loadTable(event: any) {
    const clientID = this.client_id;
    if (!clientID) return;
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }
    const request = ++this.listRequest;
    this.loadingList = true;
    this.clientUsersApi.List({
      clientID,
      body: this.filter
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: result => {
          if (this.client_id !== clientID || request !== this.listRequest) return;
          this.list = result;
          this.loadingList = false;
        },
        error: err => {
            if (this.client_id !== clientID || request !== this.listRequest) return;
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
        }
    });
  }



  getClientLogo(client: ClientViewModel | ClientModel, type: string = 'Print'): any {

    var siteName = client.SiteName?.toLocaleLowerCase();
    if (siteName == 'optodev')
      siteName = 'beta';

    //return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/DisplayLogo/${siteName}.png`);
    return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/${type}Logo/${siteName}.png`);
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {
    this.alertService.info('TO DO - Add new client');
  }


  onRowImpersonate(item: ClientUserViewModel) {
    if (item.Inactive) {
      this.alertService.error("User is inactive.");
      return;
    }
    this.clientLoginItem = item;
    this.client_users = null;
    this.clientLoginUrl = null;
    this.clientLoginVisible = true;

  }


  clientLogin() {


    this.loading = true;
    this.apiService.GetImpersonationLink({ body: { clientID: this.currentItem!.ID || 0, client_userID: this.clientLoginItem!.ID || 0 } }).forEach((r) => {
      this.loading = false;
      this.clientLoginUrl = r;
      var w = window.open(r, this.currentItem!.SiteName || '_blank');
      if (w) {
        this.clientLoginVisible = false;
      }
    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });


  }

  onRowEditInit(item: ClientViewModel) {

    this.loadingList = true;


    this.apiService.Get({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }




  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();

    //this.itemFormGroup.patchValue(this.currentItem);

  }

  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();

    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(this.currentItem);


    this.loading = true;
    this.apiService.Save({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }
      ).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));

        }
      );


  }
}
